<template>
  <div class="app-container">
    <component :is="currentComponent" :parkingInfo="selectedParking" :selectedOfferCard="selectedOfferCard"
      :discount="discount" :discountHours="selectedDiscountHours" :unpaidFee="remainingFee" :carNumber="carNumber"
      :parkingFee="parkingFee" 
      :showOtherParking="showOtherParking"
      :supportsCardDiscount="supportsCardDiscount"
      @nextStep="nextStep" @updateState="updateState" @cancel-payment="onCancel"
      @query-parking-fee="onQueryParkingFee" @go-card-discount="goCardDiscount" @go-online-payment="goOnlinePayment"
      @enter-card-number="enterCardNumber" @go-back-to-select-card="goBackToSelectCard"
      @card-number-entered="onQueryCardDiscount" @discount-hours-selected="doubleConfirm"
      @discount-hours-double-confirmed="attemptCardDiscount" @show-residual-fee="onShowResidualFee" />

    <component :is="getCurrentModal" :parkingInfo="selectedParking" :selectedOfferCard="selectedOfferCard"
      :discountHours="selectedDiscountHours" :unpaidFee="remainingFee" :carNumber="carNumber" :parkingFee="parkingFee"
      @updateState="updateState" @cancel-payment="onCancel" @query-parking-fee="onQueryParkingFee"
      @enter-card-number="enterCardNumber" @go-back-to-select-card="goBackToSelectCard"
      @card-number-entered="onQueryCardDiscount" @discount-hours-selected="doubleConfirm"
      @discount-hours-double-confirmed="attemptCardDiscount" @cancel-discount="goBackToSelectCard"
      @show-residual-fee="onShowResidualFee" @cancel-card-select="onCancelSelectCard"
      @registered-card-selected="onQueryCardDiscount" />

  </div>
  <div v-if='debug' class="payboard">
    <p> current Step {{ currentStep }}</p>
    <p>Car Number {{ carNumber }}</p>
    <p>Parking Time {{ parkingStartTime }}</p>
    <p>Parking Fee {{ parkingFee }}</p>
    <p>Card Type {{ CardSelect }}</p>
    <p>Session ID {{ sessionId }}</p>
  </div>
  <div v-if='debug' class="payboard">
    <p>Selected Offer Card {{ selectedOfferCard }}</p>
    <p>Card Number {{ cardNumber }}</p>
    <p>Expire Date {{ expireDate }}</p>
    <p>Unpaid Fee {{ unpaidFee }}</p>
    <p>Discount Hours {{ selectedDiscountHours }}</p>
    <p>Remaining Fee {{ remainingFee }}</p>
    <p>Discount {{ discount }}</p>
    <!-- <p>Seletected Parking {{ selectedParking }}</p> -->
    <p> parking Info {{ selectedParking.parking_id }} | {{ selectedParking.title }} {{ selectedParking.address }} # {{
      selectedParking.agreement_id }}</p>




  </div>
  <div v-if="isLoading">
    <LoadingSpinner loadingText="車號查詢中…請稍後" />
  </div>
</template>

<script>
import { queryParkingFee, doCardDiscount, closeSession } from '@/util/parkingpayment';
// import { queryParkingFee, doCardDiscount } from '@/util/parkingpayment';
// import { queryParkingFee } from '@/util/parkingpayment';

import { globalParams } from '@/global';


import CarNumber from './payment/CarNumber.vue';
import CarFee from './payment/CarFee.vue';
import CardSelect from './payment/CardSelect.vue';
import CardSelectLogined from './payment/CardSelectLogined.vue';
import CardNumberEntry from './payment/CardNumberEntry.vue';
import CalculateDiscount from './payment/CalculateDiscount.vue';
import SelectDiscountHours from './payment/SelectDiscountHours.vue';
import MyConfirm from './payment/MyConfirm.vue';
import DoubleConfirm from './payment/DoubleConfirm.vue';
import DisplayResidualFee from './payment/DisplayResidualFee.vue';
import ShowSuccess from './payment/ShowSuccess.vue';
import RemainFee from './payment/RemainFee.vue';

import LoadingSpinner from '@/components/LoadingSpinner.vue';

// import { onMounted } from 'vue';
// import ParkingPaymentDAO from '@/services/ParkingPaymentDAO';




export default {

  data() {
    return {
      debug: process.env.VUE_APP_ENABLE_CARD_DISCOUNT_DEBUG === 'true',
      selectedParking: globalParams.selectedParking,
      currentStep: 'CarNumber', // Tracks which step we are in
      currentModal: '',
      steps: [
        'CarNumber',
        'CarFee',
        'CardSelect',
        'CardSelectLogined',
        'CardNumberEntry',
        'CalculateDiscount',
        'SelectDiscountHours',
        'MyConfirm',
        'DoubleConfirm',
        'DisplayResidualFee',

      ],
      carNumber: '',
      parkingStartTime: '',
      CardSelect: '',
      parkingFee: 0,
      sessionId: '',
      // 金額變動確認後只允許重送一次，避免一直跳確認框
      feeChangeRetried: false,
      selectedOfferCard: '',
      cardNumber: '',
      expireDate: '',
      selectedDiscountHours: 0,
      remainingFee: 0,
      discount: 0,
      isLoading: false,
      showOtherParking: true

    };
  },
  computed: {
    // ...mapGetters(['selectedParking']),

    currentComponent() {
      // Return the component name based on the current step
      return this.currentStep;
    },

    getCurrentModal() {
      return this.currentModal;
    },

    supportsCardDiscount() {
      const agreementId = this.selectedParking && this.selectedParking.agreement_id;
      return agreementId !== null && agreementId !== undefined && String(agreementId).trim() !== '';
    }

  },
  methods: {
    async onQueryParkingFee() {
      this.isLoading = true;
      //query car fee
      try {
        const restt = await queryParkingFee(this.selectedParking.parking_id, this.carNumber,
          this.selectedParking.longitude, this.selectedParking.latitude
        );
        this.parkingFee = restt.fee;
        this.sessionId = restt.session_id;
        this.feeChangeRetried = false;   // 新的一筆交易，重設旗標
        this.remainingFee = restt.remainingFee;
        this.discount = restt.discount;
        this.currentStep = 'CarFee';
        this.parkingStartTime = restt.startTime.replace('T', ' ');
        this.selectedParking.startTime = this.parkingStartTime;
      } catch (error) {
        this.isLoading = false;

        alert('查無停車費用，請重新輸入車牌號碼；或是該車號正在繳費處理中，請稍後再試');
        this.currentStep = 'CarNumber';
      }

      this.isLoading = false;
      // this.parkingFee = await queryParkingFee(this.selectedParking.id, this.carNumber);
      // this.currentStep = 'CarFee';
    },

    nextStep() {
      // Move to the next step
      // const currentIndex = this.steps.indexOf(this.currentStep);
      // this.currentStep = this.steps[currentIndex + 1];
    },

    updateState({ key, value }) {
      this[key] = value; // Update the state dynamically
      console.log('updateState', key, value);
    },

    // calculateDiscount() {
    //   const maxDiscount = 5; // Mock calculation logic
    //   this.selectedDiscountHours = Math.min(this.selectedDiscountHours, maxDiscount);
    //   this.unpaidFee = this.parkingFee - this.selectedDiscountHours * 10; // Example fee calculation
    //   return this.unpaidFee;
    // },

    onCancel() {
      this.carNumber = '';
      this.CardSelect = '';
      this.selectedOfferCard = '';
      this.sessionId = '';
      this.cardNumber = '';
      this.selectedDiscountHours = 0;
      this.remainingFee = 0;
      this.currentStep = 0;

      //goto OnlinePayment
      const prevRout = globalParams.prevRoute;
      this.$router.push(prevRout);

    },

    goCardDiscount() {
      if (!this.supportsCardDiscount) {
        return;
      }

      if (this.$store.getters.user) {
        this.currentModal = 'CardSelectLogined';
      } else {
        // this.currentModal = 'CardSelect';
        this.enterCardNumber();
      }
    },

    async goOnlinePayment() {
      // https://webpay.fortune88.com.tw/PayFromCloud/SelectedAndPay?FieldNo=  J009(場號) &Car= AAA1234查詢的車號

      this.isLoading = true;
      
      //  need to close transaction 
      try {
        const close_status = await closeSession(this.selectedParking.parking_id, this.carNumber);
        console.log('close_status', close_status);
      } catch (error) {
        console.error('Error closing session:', error);
        console.log('But still proceed to payment');
        // alert('無法關閉停車費用，請稍後再試');
        // this.isLoading = false;
        // return;
      }

      this.isLoading = false;

      // Add your payment process logic here
      const paymentUrl = 'https://webpay.fortune88.com.tw/PayFromCloud/SelectedAndPay?FieldNo=' + this.selectedParking.parking_id + '&Car=' + this.carNumber;
      console.log('Proceeding to online payment for parking:', this.selectedParking);

      // console.log('Proceeding to payment for parking:', this.selectedParking);
      // console.log("pyament modal visible:", this.isPaymentModalVisible);
      //move the user to the payment page
      window
        .open(paymentUrl, '_blank')
        .focus();
    },

    enterCardNumber() {
      this.currentModal = 'CardNumberEntry';
    },

    goBackToSelectCard() {
      if (this.$store.getters.user) {
        this.currentModal = 'CardSelectLogined';
      } else {
        // this.currentModal = 'CardSelect';
        this.currentModal = '';
      }
    },

    onCancelSelectCard() {
      this.currentModal = '';
    },

    async onQueryCardDiscount() {
      //query card discount
      // const parking_id = this.selectedParking.id;

      // const canDiscountHours = await queryCardDiscount(parking_id, this.carNumber, this.cardNumber);
      const canDiscountHours = 1;
      // alert('canDiscountHours', canDiscountHours);
      if (canDiscountHours > 0) {
        this.selectedDiscountHours = canDiscountHours;
        this.currentModal = 'SelectDiscountHours';


      } else if (canDiscountHours === 0) {
        alert('已經沒有可以折抵的時數');
        this.currentModal = 'CardNumberEntry';
      } else {
        alert('查詢折抵時數失敗，請重新輸入卡號');
        this.currentModal = 'CardNumberEntry';
      }
    },

    doubleConfirm() {
      this.currentModal = 'DoubleConfirm';
    },

    async attemptCardDiscount() {
      if (!this.supportsCardDiscount) {
        this.currentModal = '';
        return;
      }

      this.isLoading = true;

      //if discount > 0, then wait 2 seconds and alert this parking fee is already discounted , procees to online payment 
      if (this.discount > 0) {
        //wait 2 seconds
        await new Promise(resolve => setTimeout(resolve, 1000));
        alert('此停車費已折抵過，請直接繳費');
        this.onShowResidualFee();
        this.isLoading = false;
        this.currentModal = '';

        return;
      }

      // alert("attemptCardDiscount");
      // if (this.discount <=0 )
      // {
      //   this.currentModal = 'ShowSuccess';
      //   this.isLoading = false;
      //   return;
      // }

      try {

        const agreement_id = this.selectedParking.agreement_id;
        // const agreement_id = null;
        console.log('attemptCardDiscount', this.sessionId, this.parkingFee, this.cardNumber, this.expireDate, agreement_id);

        const discountInfo = await doCardDiscount(this.sessionId, this.parkingFee, this.cardNumber, this.expireDate, this.parkingStartTime, agreement_id);
        console.log('discountInfo', discountInfo);
           

        // ── 逾時保護（後端可能回 reason）──────────────────────
        if (discountInfo.reason === 'fee_changed') {
          // 停留超過門檻，後端重開 session 後發現跨了計費區間。
          // 一定要讓客人自己決定，不能拿新金額直接去刷卡。
          const ok = confirm(
            `停車費已更新為 ${discountInfo.new_fee} 元（原 ${discountInfo.old_fee} 元），是否繼續折抵？`
          );
          if (!ok) {
            this.isLoading = false;
            this.goBackToSelectCard();
            return;
          }
          if (this.feeChangeRetried) {
            alert('停車費持續變動，請重新查詢車號');
            this.isLoading = false;
            this.onCancel();
            return;
          }
          this.feeChangeRetried = true;
          this.sessionId = discountInfo.session_id;
          this.parkingFee = discountInfo.new_fee;
          this.isLoading = false;
          return this.attemptCardDiscount();
        }

        if (discountInfo.reason === 'apply_failed') {
          // 卡片已經授權成功，只是折抵沒套上。不要把客人送回選卡畫面，
          // 否則他順手再刷一次就會被扣兩次紅利。
          alert(discountInfo.message);
          this.isLoading = false;
          this.currentModal = '';
          return;
        }

        if (discountInfo.reason) {
          alert(discountInfo.message || '折抵失敗，請重新查詢車號');
          this.isLoading = false;
          this.onCancel();
          return;
        }

        const residualFee = discountInfo.residual_fee;
        const discount = discountInfo.discounted_fee;

        console.log('residualFee', residualFee);

        if (residualFee >= 0) {
          this.remainingFee = residualFee;
          this.discount = discount;
          this.currentModal = 'ShowSuccess';
        } else {
          alert('無可折抵紅利');
          this.goBackToSelectCard();
        }
      } catch (error) {
        // alert('無可折抵紅利');
        alert(error || '無可折抵紅利');
        this.goBackToSelectCard();
      }

      this.isLoading = false;
    },



    // goCalculateDiscount() {

    //   this.parkingFee = this.calculateDiscount();
    //   alert('calculate discount', this.parkingFee);

    //   this.currentStep = 'CarFee';
    // },

    async onShowResidualFee() {
      try {
        // const restt = await queryParkingFee(this.selectedParking.parking_id, this.carNumber,
        //   this.selectedParking.longitude, this.selectedParking.latitude
        // );
        // this.parkingFee = restt.fee;

        this.currentStep = 'RemainFee';
        // this.resetData();

      } catch (error) {
        alert('查無停車費用，請重新輸入車牌號碼');
        this.currentStep = 'CarNumber';
        this.resetData();

      }
      //clear all other variables
      // this.carNumber = '';


    },

    resetData() {

      this.CardSelect = '';
      this.selectedOfferCard = '';
      this.cardNumber = '';
      this.selectedDiscountHours = 0;
      this.unpaidFee = 0;
      // this.currentStep = 0;
    }




  },
  mounted() {
    // wait for the page to load
    // this.parkingTitle = this.selectedParking.title;
    // alert(this.parkingTitle);

  },
  components: {
    LoadingSpinner,
    CarNumber,
    CarFee,
    CardSelect,
    CardSelectLogined,
    CardNumberEntry,
    CalculateDiscount,
    SelectDiscountHours,
    MyConfirm,
    DoubleConfirm,
    ShowSuccess,
    DisplayResidualFee,
    RemainFee
  }
};
</script>

<style scoped>
.app-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  background-color: #f5f5f5;
}

.payboard {
  display: flex;
  /* flex-direction: column; */
  gap: 30px;
  justify-content: center;
  align-items: center;
  min-height: 10vh;
  background-color: #b6fff6;
}
</style>
